module.exports = __webpack_public_path__ + "img/sword-earth-01.9a838c82.png";